export const UI = {
  sm: 640,
};
